import apiClient from "../config/api";

const hazardCategoryService = {
  /**
   * Get all hazard categories with subcategories
   * @returns {Promise<Array>}
   */
  getCategories: async () => {
    const response = await apiClient.get("/HazardCategory");
    return response.data;
  },

  /**
   * Get a single hazard category by ID
   * @param {number} id
   * @returns {Promise<object>}
   */
  getCategory: async (id) => {
    const response = await apiClient.get(`/HazardCategory/${id}`);
    return response.data;
  },

  /**
   * Create a new hazard category
   * @param {object} categoryData
   * @returns {Promise<object>}
   */
  createCategory: async (categoryData) => {
    const response = await apiClient.post("/HazardCategory", categoryData);
    return response.data;
  },

  /**
   * Update a hazard category
   * @param {number} id
   * @param {object} categoryData
   * @returns {Promise<object>}
   */
  updateCategory: async (id, categoryData) => {
    const response = await apiClient.post(`/HazardCategory/update/${id}`, categoryData);
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await apiClient.post(`/HazardCategory/delete/${id}`);
    return response.data;
  },
};

export default hazardCategoryService;
